import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { latLng, MapOptions, tileLayer, Map, Marker, icon, LeafletMouseEvent } from 'leaflet';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit {
  mapOptions: MapOptions;
  map: Map;
  myMarker: Marker;
  onAdd = new EventEmitter();
  isModifica: boolean;

  onButtonClick() {
    const currentLatLng = this.myMarker.getLatLng();
    const formattedLat = parseFloat(currentLatLng.lat.toFixed(7));
    const formattedLng = parseFloat(currentLatLng.lng.toFixed(7));
    this.onAdd.emit({ lat: formattedLat, lng: formattedLng });
    this.dialogRef.close();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<MapComponent>) { }

  ngOnInit(): void {
    this.mapOptions = {
      center: latLng(this.data.x, this.data.y),
      zoom: 8,
      layers: [
        tileLayer(
          'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          {
            maxZoom: 18,
            attribution: 'Map data © OpenStreetMap contributors'
          })
      ],
    };
    this.isModifica = this.data.isModifica;
  }

  onMapReady(map: Map) {
    this.map = map;
    this.addSampleMarker();
    if (this.isModifica) {
      this.map.on('click', (e: LeafletMouseEvent) => {
        //Add marker
        this.myMarker.setLatLng(e.latlng);
      });
    }
  }

  private addSampleMarker() {
    this.myMarker = new Marker([this.data.x, this.data.y], { draggable: true})
      .setIcon(
        icon({
          iconSize: [25, 41],
          iconAnchor: [13, 41],
          iconUrl: 'assets/images/marker-icon.png'
        }));
    this.myMarker.addTo(this.map);
  }

  onClose(){
      this.dialogRef.close();
  }
}
